import { useSupportedChains } from "@hl/shared-features/lib/features/chain";
import { getCurrencySymbol } from "@hl/shared-features/lib/utils/currency";
import { ethers } from "ethers";

import { useCreateCollectionFormContext } from "~/features/collections/forms/CreateCollectionMultistepForm/context";

const useCurrencyDisplay = () => {
  const form = useCreateCollectionFormContext();
  const formValues = form.values;

  const { supportedChains } = useSupportedChains(
    formValues.collection.chainId == null ||
      formValues.distribution.currency == null
  );

  const chain = supportedChains.find(
    (chain) => chain.chainId.toString() === formValues.collection.chainId
  );
  const paymentCurrency = chain?.supportedPaymentCurrencies.find(
    (chain) =>
      formValues.distribution.currency &&
      ethers.utils.getAddress(chain.address) ===
        ethers.utils.getAddress(formValues.distribution.currency)
  );

  const displayCurrency = getCurrencySymbol(
    formValues.collection.chainId,
    paymentCurrency?.symbol
  );

  return {
    displayCurrency,
    paymentCurrency,
  };
};

export default useCurrencyDisplay;
export type UseCurrencyDisplay = ReturnType<typeof useCurrencyDisplay>;
